module.exports = __webpack_public_path__ + "static/media/29ADMSPC37.917a1dc3.jpg";